// s09-notable-pgp-sites

import selfHtml from './s09-notable-pgp-sites.html' with { type: 'text' };;


var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root
}